import React,{Component} from 'react';
import WebHeaderInner from './WebHeaderInner.js';
import WebFooter from './WebFooter.js';
import {Modal} from 'react-bootstrap';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
// const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_Advertise extends Component{
  constructor(props){	
    super(props);
    this.state={
    	contact_err:'',
    	name_err:'',
    	email_err:'',
    	phone_err:'',
      
      utype:1,
      message:'',
      response:false,

      email:'',
      mobile:'',
      name:'',

    }
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleChange =this.handleChange.bind(this);
    this.nameChange =this.nameChange.bind(this);
    this.mobileChange =this.mobileChange.bind(this);
    this.close =this.close.bind(this);
  }
  close()
  {
    this.setState({response:false});
  }
  componentDidMount()
  {
      window.scrollTo(0, 0);                
  }
   handleSubmit(event)
   {
   	  // var contact = this.refs.contact.value;
   	  var name = this.refs.name.value;
   	  var email =this.refs.email.value;
   	  var mobile =this.refs.phone.value;
      var company =this.refs.company.value;
      var invalidChars = /[^a-zA-Z ]/gi;
      var invalidNumber = /[^0-9]/gi;
      var emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
      // var contact ="User";
      var flag = 0;
      

     if(name === '')
      {
      	this.setState({name_err:'Please enter name'});
        flag=1;
      }
      else if(invalidChars.test(name))
      {
      	this.setState({name_err:'Please enter valid name'});
        flag=1;
      }
      else if(name.length < 3)
      {
      	this.setState({name_err:'Minimum length should be 3 characters'});
        flag=1;
      }
      else
      {
         this.setState({name_err:''});
     
      }
      if(email === '')
      {
   		  this.setState({email_err:'Please enter Email'});
        flag=1;
      }
      else if(!emailPattern.test(email))
      {
        this.setState({email_err:'Please enter valid Email'});
        flag=1;
      }
      else
      {
      	this.setState({email_err:''});
      	 flag=0;
      }

      if(mobile === '')
      {
      	this.setState({phone_err:'Please enter Phone Number'});
        flag=1;
      }
      else if(invalidNumber.test(mobile))
      {
      	this.setState({phone_err:'Please enter valid Phone Number'});
        flag=1;
      }
      else if(mobile.length < 10)
      {
      	this.setState({phone_err:'Please enter valid Phone Number'});
        flag=1;
      }
      else
      {
        this.setState({phone_err:''});
      }   
      
      
    if(localStorage.user_id)
    {
      var uid=localStorage.user_id;
    }
    else
    {
      uid=0;
    }
    var url=window.location.href;

    if(localStorage.source)
    {
      var source=localStorage.getItem('source');
    }
    else
    {
      source='';
    }
    if(localStorage.campaign)
    {
      var campaign=localStorage.getItem('campaign');
    }
    else
    {
      campaign='';
    }
    if(localStorage.url_id)
    {
      var url_id=localStorage.getItem('url_id');
    }
    else
    {
      url_id='';
    }
       
    // advertiseWithUs(id,name,email,mobile,company,utype,from)
       var data1 ={from:'desktop_web',id:uid,token:localStorage.token,utype:this.state.utype,name:name,email:email,mobile:mobile,company:company,source:source,campaign:campaign,url_id:url_id,url:url};
       var data2 =JSON.stringify(data1);
      if(flag === 0)
       {
         $.ajax({
            url:baseUrl+'advertiseWithUs',
            method:'POST',
            dataType:'JSON',
            data:{req:data2},
            success:function(data)
            {
                if(data.status === 'success')
                {
                   this.setState({
                      message:data.msg, 
                      response:true,
                      mobile:'',
                      name:'',
                   });
                }
                if(data.status === 'error')
                {
                   this.setState({
                      message:data.msg,
                      response:true,
                      mobile:'',
                      name:'',
                   });
                }
                this.refs.name.value="";
                this.refs.email.value="";
                this.refs.phone.value="";
                this.refs.company.value="";
            }.bind(this),
            error:function(err)
            {

            }

         });
       } 

        event.preventDefault();
  }
   handleChange(event)
   {
     this.setState({utype:event.target.value});
   }
   nameChange(event)
  {
    
    var x=event.target.value;
    var invalidChars = /[^a-zA-Z ]/gi;
      if(invalidChars.test(event.target.value)) {
          x = event.target.value.replace(invalidChars,"");
      }
      else
      {
        this.setState({
              name:x,
       });
      }
  }
  mobileChange(event)
  {
    var x=event.target.value;
    var invalidChars = /[^0-9]/gi;
      if(invalidChars.test(event.target.value)) {
          x = event.target.value.replace(invalidChars,"");
      }
      else
      {
        this.setState({
            mobile: x,
          });
      }
  }
  render()
  {
    document.title = "Advertise With Us | AquaDeals";
	return(
		<div>	
			<WebHeaderInner />	
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			   <div className="container web_advertise_page" style={{marginTop:'30px',marginBottom:'20px'}}>	 
			     <div className="row">
			     
			     <div className="clr">&nbsp;</div>
			     <div className="clr">&nbsp;</div>
            <h3 className="contact_hdr">Advertise With Us</h3>
			      <form onSubmit={this.handleSubmit}> 
    			        <div className="container advertise_form">
        					  <div className="contact_filed">
        							   <label>I am a</label>
        							   {/*<input type="text" ref="contact"/>*/}
        							   <select className="selectbox" value={this.state.value}  onChange={this.handleChange}>
                           <option value="1">User</option>
                           <option value="2">Dealer</option>
                           <option value="3">Manufacturer</option>
                         </select>
                         <p className="error">{this.state.contact_err ?this.state.contact_err:'' }</p>
        						  </div>
              				<div className="clr">&nbsp;</div>
          						 <div className="clr">&nbsp;</div>
            						<div className="row form_fileds">  
            						  <div className="advertise_group col-xs-3 col-lg-3 col-md-3">
            						    <input type="text" ref="name" placeholder="Name" value={this.state.name} onChange={this.nameChange}/>
            						     <span className="bar"></span>
            					        <p className="error">{this.state.name_err ?this.state.name_err:'' }</p>
            					      </div>
            						  <div className="advertise_group col-xs-3 col-lg-3 col-md-3">
            						    <input type="text" ref="email" placeholder="Email" />
            						      <span className="bar"></span>
            					        <p className="error">{this.state.email_err ? this.state.email_err : ''}</p>
            					      </div>
            						  <div className="advertise_group col-xs-3 col-lg-3 col-md-3">
            						    <input type="text" ref="phone" placeholder="Phone Number" maxLength="10" value={this.state.mobile} onChange={this.mobileChange}/>
            						    <span className="bar"></span>
            					       <p className="error">{this.state.phone_err ? this.state.phone_err :''}</p>
            						  </div>
            						  <div className="advertise_group col-xs-3 col-lg-3 col-md-3">
            						    <input type="text" ref="company"  placeholder="Company"/>
            						    <span className="bar"></span>
            					      </div>
            						</div>  
            					 </div> 
            					 <div className="clr">&nbsp;</div>
            					 <div className="clr">&nbsp;</div>
            					 <div className="text-center">
            					   <input type="submit" className="btn  advertise_submit" value="SUBMIT" /> 
            					 </div>
			          </form>
             </div>  
             <Modal  show={this.state.response} onHide={this.close} >
                <Modal.Body style={{padding:'35px'}}>
                  <div className="advertise_msg">
                    <p>{this.state.message}</p>
                    <a onClick={this.close}>OK</a>
                  </div>
                </Modal.Body>
             </Modal>
			     </div> 
		    <WebFooter />
     </div>
	);
  }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_Advertise.js
 **/